import { Button, Dropdown, Select } from 'antd';
import type { MenuProps } from 'antd';
import { AppstoreOutlined, MoreOutlined, QrcodeOutlined } from '@ant-design/icons';

type BranchOption = {
  id: string;
  name: string;
  level?: number;
};

export type LocationsHeaderProps = {
  branches?: BranchOption[] | null;
  selectedBranchId: string | null;
  onBranchChange: (value: string) => void;
  onOpenCategories: () => void;
  onOpenQrLabels?: () => void;
  pageMenuItems: MenuProps['items'];
  onPageMenuClick: MenuProps['onClick'];
};

export function LocationsHeader({
  branches,
  selectedBranchId,
  onBranchChange,
  onOpenCategories,
  onOpenQrLabels,
  pageMenuItems,
  onPageMenuClick,
}: LocationsHeaderProps) {
  return (
    <div style={{ marginBottom: 16, display: 'flex', alignItems: 'center', gap: 16, flexWrap: 'wrap' }}>
      <h1 style={{ margin: 0, fontSize: '24px', fontWeight: 'bold' }}>
        エリア管理
      </h1>
      {branches && branches.length > 0 && (
        <>
          <Select
            style={{ width: 300 }}
            placeholder="拠点を選択"
            value={selectedBranchId}
            onChange={onBranchChange}
            showSearch
            optionFilterProp="label"
            options={branches.map(branch => {
              // Generate hierarchical label with tree lines
              const level = (branch as { level?: number }).level ?? 0;
              const indent = level > 0
                ? '│  '.repeat(level - 1) + '├─ '
                : '';
              return {
                label: (
                  <span style={{ fontFamily: 'monospace' }}>
                    {indent}{branch.name}
                  </span>
                ),
                value: branch.id,
                searchLabel: branch.name, // For filtering
              };
            })}
            filterOption={(input, option) => {
              const searchLabel = (option as { searchLabel?: string })?.searchLabel ?? '';
              return searchLabel.toLowerCase().includes(input.toLowerCase());
            }}
          />
          <Button icon={<AppstoreOutlined />} onClick={onOpenCategories}>
            カテゴリ管理
          </Button>
          {onOpenQrLabels && (
            <Button icon={<QrcodeOutlined />} onClick={onOpenQrLabels}>
              QRコードシール印刷
            </Button>
          )}
          <Dropdown
            menu={{ items: pageMenuItems, onClick: onPageMenuClick }}
            trigger={['click']}
            placement="bottomRight"
          >
            <Button type="text" icon={<MoreOutlined />} aria-label="ページメニュー" />
          </Dropdown>
        </>
      )}
    </div>
  );
}
